'use client'
import { ReactNode, useContext, useEffect, useState } from 'react'
import AppDownloadModal from '../../components/Modals/AppDownloadModal'
import Sidebar from '../../components/Sidebar/Sidebar'
import TrialAlert from '../../components/TrialAlert/TrialAlert'
import useCrisp from '../../hooks/useCrisp'
import useCompanySubscription from '../../hooks/queries/useCompanySubscription'
import AuthContext from '../../context/AuthContext'
import { useRouter, useSearchParams } from 'next/navigation'
import { isRegistrationComplete } from '../../services/auth'

const DashboardLayout = ({ children }: { children: ReactNode }) => {
	const [isDownloadAppDialogOpen, setIsDownloadAppDialogOpen] = useState(false)
	const { companySubscription } = useCompanySubscription()
	const authContext = useContext(AuthContext)
	const router = useRouter()
	const searchParams = useSearchParams()

	const subscriptionName = companySubscription?.name ?? ''

	useCrisp(subscriptionName)

	useEffect(() => {
		if (!authContext.loggedIn) {
			const paramsToPreserve = ['invite', 'cid', 'token']
			const newParams = new URLSearchParams()
			paramsToPreserve.forEach(key => {
				const value = searchParams?.get(key)
				if (value) newParams.set(key, value)
			})
			const queryString = newParams.toString()
			router.replace(queryString ? `/login?${queryString}` : '/login')
		} else if (!isRegistrationComplete(authContext.user)) {
			router.replace(`/register?${searchParams?.toString()}`)
		}
	}, [authContext.company, authContext.loggedIn, authContext.user, authContext.loading, router, searchParams])

	return (
		<div className="flex md:flex-row flex-col mx-auto">
			<div className="w-full md:w-80 shrink-0">
				<Sidebar
					openDownloadModal={() => setIsDownloadAppDialogOpen(true)}
					subscriptionName={subscriptionName}
				/>
			</div>
			<div className="p-4 md:p-10 w-full">
				<TrialAlert />
				<div className="flex flex-row justify-end">
					<AppDownloadModal isOpen={isDownloadAppDialogOpen} setIsOpen={setIsDownloadAppDialogOpen} />
				</div>
				{children}
			</div>
		</div>
	)
}

export default DashboardLayout
